export default __webpack_public_path__ + "static/card-9-499769e11fb24ebdc73d2521382f1ed0.png";